export function ConnectionStatusCard(): JSX.Element {
  return (
    <section className="rounded-md border border-border bg-card p-5">
      <h2 className="font-mono text-xs uppercase tracking-[0.2em] text-text-dim mb-3">
        Connection
      </h2>
      <dl className="space-y-2 text-sm">
        <Row label="WiFi RSSI">
          <span className="text-text-dim">— not reported</span>
        </Row>
        <Row label="Hub ID">
          <span className="text-text-dim">— not reported</span>
        </Row>
        <Row label="AWS latency">
          <span className="text-text-dim">— not reported</span>
        </Row>
      </dl>
      <p className="mt-3 text-[10px] text-muted">
        Hub diagnostics surface from the dongle&apos;s next firmware drop.
      </p>
    </section>
  );
}

function Row({
  label,
  children,
}: {
  readonly label: string;
  readonly children: React.ReactNode;
}): JSX.Element {
  return (
    <div className="flex items-baseline justify-between gap-3">
      <dt className="font-mono text-[10px] uppercase tracking-[0.2em] text-text-dim">
        {label}
      </dt>
      <dd>{children}</dd>
    </div>
  );
}
